import { FC } from "react";
import Stack from "@mui/material/Stack";
import { Skeleton, Typography } from "@mui/material";
import { money } from "@/utils/numeral/money";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsByIdLoadingSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdLoadingSelector";
import { budgetDetailsAccumulatedCostLoadingSelector } from "@/store/budgets/selectors/details-drawer/accumulated-cost/budgetDetailsAccumulatedCostLoadingSelector";

interface BudgetDetailsAccumulatedCostChipProps {
  title: string;
  cost?: number | null;
}

export const BudgetDetailsAccumulatedCostChip: FC<
  BudgetDetailsAccumulatedCostChipProps
> = ({ title, cost }) => {
  const detailsLoading = useAppSelector(budgetDetailsByIdLoadingSelector);
  const accumulatedCostLoading = useAppSelector(
    budgetDetailsAccumulatedCostLoadingSelector,
  );

  const loading = detailsLoading || accumulatedCostLoading;

  return (
    <Stack py={0.5} pl={1} pr={3}>
      <Typography
        variant="subtitle2"
        color="text.secondary"
        fontWeight="normal"
      >
        {title}
      </Typography>
      {loading ? (
        <Skeleton width={75} height={24} />
      ) : (
        <Typography variant="body1" fontWeight="bold">
          {money(cost)}
        </Typography>
      )}
    </Stack>
  );
};
